import React from "react";
import "./Stats.css";
import { motion } from "framer-motion";

import {
  FaStar,
  FaUserGraduate,
  FaBriefcase,
  FaBuilding,
  FaChartLine,
  FaTrophy,
} from "react-icons/fa";

const Stats = () => {
  const statsData = [
    { icon: <FaStar />, value: "10+", label: "Years Experience" },
    { icon: <FaUserGraduate />, value: "2000+", label: "Students Trained" },
    { icon: <FaBriefcase />, value: "100%", label: "Placement Assistance" },
    { icon: <FaBuilding />, value: "150+", label: "Hiring Partners" },
    { icon: <FaChartLine />, value: "45%", label: "Average Hike" },
    { icon: <FaTrophy />, value: "95%", label: "Job Success" },
  ];

  return (
    <section className="stats">
      <div className="stats-container">
        {statsData.map((item, index) => (
          <motion.div
            key={index}
            className="stat-box"
            initial={{
              opacity: 0,
              x: index % 2 === 0 ? -60 : 60,
            }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{
              duration: 0.6,
              delay: index * 0.2,
            }}
            whileHover={{ scale: 1.08 }}
            viewport={{ once: true }}
          >
            <div className="icon">{item.icon}</div>
            <h2>{item.value}</h2>
            <p>{item.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
